import { ContentSectionConverter } from './ContentSectionConverter';
import { createContent } from '../content/contentBuilder/Content';
import { RootHelper } from '../content/contentBuilder/Root';
export const ContentConverter = {
    convertToDomainModel: (content) => {
        const sectionsServer = content.sections;
        if (!content.id) {
            throw Error('Failed converting content, doesnt have id');
        }
        try {
            const result = sectionsServer.reduce((acc, sectionServer) => {
                const { sectionId, fragments } = ContentSectionConverter.convertServerModel(sectionServer);
                return {
                    sectionIds: [...acc.sectionIds, sectionId],
                    fragments: [...acc.fragments, ...fragments],
                };
            }, { sectionIds: [], fragments: [] });
            const contentConverted = RootHelper.build(content.id, result.sectionIds);
            return createContent(content.id, [contentConverted, ...result.fragments]);
        }
        catch {
            throw Error(`Failed converting content with id: ${content.id}`);
        }
    },
    convertToServerModel: (content) => {
        const root = content.fragmentsById.get(content.rootId);
        const sections = root.value.sections.map((sectionId) => {
            const section = content.fragmentsById.get(sectionId);
            return ContentSectionConverter.covertToServerModel(section, content);
        });
        return {
            id: content.rootId,
            sections,
        };
    },
};
